import React, { forwardRef, JSX } from 'react';
import { i18n } from '../../../i18n/translate';
import { onExecuteKeyDown } from '../../../utils/KeyboardUtil';
import { RadioGroup } from '@chakra-ui/react';
import { Button as CoreButton, Modal as CoreModal, Layout, Radio } from '../../../core';

interface Props {
  buttonDisabled: boolean;
  confirmSelection: () => void;
  enforceSelection: boolean;
  languages: object;
  onClose: () => void;
  renderedTitle: JSX.Element;
  selected: string;
  setSelected: (selected: string) => void;
  showLanguageModal: boolean;
}

const LanguageModalBody = forwardRef<HTMLInputElement, Props>(
  (
    {
      buttonDisabled,
      confirmSelection,
      enforceSelection,
      languages,
      onClose,
      renderedTitle,
      selected,
      setSelected,
      showLanguageModal,
    },
    ref
  ) => {
    return (
      <CoreModal
        // @ts-ignore
        ref={ref}
        size="sm"
        id="languages-modal"
        isOpen={showLanguageModal}
        modalType={'modal'}
        onClose={onClose}
        showCloseButton={!enforceSelection}
        variant={'default'}
        header={renderedTitle}
        footer={
          <>
            <CoreButton onClick={onClose} variant={'secondary'}>
              {i18n.t('Cancel')}
            </CoreButton>
            <CoreButton
              isDisabled={buttonDisabled}
              onClick={confirmSelection}
              variant="primary"
              data-action="save-language"
            >
              {i18n.t('Save')}
            </CoreButton>
          </>
        }
      >
        <RadioGroup.Root
          data-object-type="language-modal-body"
          onValueChange={details => setSelected(details.value ?? '')}
          value={selected}
        >
          <Layout variant="stack" direction="column">
            {Object.entries(languages).map(([code, { native_name }]) => {
              const isSelected = selected === code;
              return (
                <Radio
                  label={native_name}
                  key={code}
                  value={code}
                  tabIndex={-1}
                  aria-pressed={isSelected}
                  onKeyDown={onExecuteKeyDown(() => setSelected(code))}
                  data-object-type="languages"
                  data-object-id={code}
                  data-selected={isSelected}
                />
              );
            })}
          </Layout>
        </RadioGroup.Root>
      </CoreModal>
    );
  }
);
LanguageModalBody.displayName = 'LanguageModalBody';

export { LanguageModalBody };
